module.exports = __webpack_public_path__ + "img/syukyaku-dtp-002.a19936c4.jpg";